import {roomService} from "../network/services/room.service";

export default {
    namespaced: true,
    state: {
        equipments: [],
        picked: [],
        loading: false,
        init: false
    },
    mutations: {
        SET_LOADING (state, payload) {
            state.loading = !!payload;
        },
        SET_EQUIPMENTS (state, equipments) {
            state.equipments = equipments;
        },
        SET_PICKED (state, equipments) {
            if (!equipments) return state.picked = [];
            equipments.forEach((e) => {
                if (typeof e === 'string' || typeof e === 'number') {
                    state.picked.push(e);
                    return;
                }
                if (e.id) state.picked.push(e.id);
            })
        },
        TOGGLE_PICKED (state, id) {
            const index = state.picked.indexOf(id);
            if (index === -1) {
                /* ---
                 * remove not stackable
                 */
                const equipments = state.equipments.filter(e => e.id === id);
                if (equipments.length !== 0) {
                    const equipment = equipments[0];
                    for (const notW of equipment.not_stackable_with) {
                        const subIndex = state.picked.indexOf(notW);
                        if (subIndex !== -1) {
                            state.picked.splice(subIndex, 1);
                        }
                    }
                }

                /* ---
                 * remove all not compatible with
                 */
                for (const pick of state.picked) {
                    const equipment = state.equipments.filter(e => e.id === pick)[0];
                    if (equipment.not_stackable_with.indexOf(id) !== -1) {
                        state.picked.splice(state.picked.indexOf(pick), 1);
                    }
                }

                state.picked.push(id);
                return;
            }
            return state.picked.splice(index, 1);
        },
        INIT (state) {
            state.init = true;
        }
    },
    actions: {
        async fetch (context, force = false) {
            if (context.rootState.equipment.init && !force) return;
            context.commit('INIT');
            const lang = context.rootState.lang.currentLang;
            context.commit('SET_LOADING', true);
            const response = await roomService.fetchEquipments({
                lang
            });
            const equipments = response.get('RoomEquipment.many', []);
            context.commit('SET_EQUIPMENTS', equipments);
            context.commit('SET_LOADING', false);
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/equiment.store.js